<template>
    <div class="app-risk-warning">
        <p class="mb-0">
            <span v-if="name">{{ name }}. </span>
            <span>{{ $t('risk_warning_text') }}</span>
            <a href="/risk-summary">
                {{ $t('take_2_mins_to_learn_more') }}
                <v-icon>{{ getIcon('right') }}</v-icon>
            </a>
        </p>
    </div>
</template>

<script>
export default {
    name: 'AppRiskWarning',
    computed: {
        name() {
            const name = this.Auth().user ? this.Auth().user.name : null;

            if (!name) {
                return null;
            }

            return name.trim().split(' ')[0];
        }
    }
};
</script>
<style lang="scss" scoped>
.app-risk-warning {
    position: sticky;
    z-index: 6;
    top: 0;
    left: 0;
    right: 0;
    min-height: var(--v-app-risk-warning-height);
    background: var(--v-primaryText-base);
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;

    p {
        font-size: 0.95rem;
        color: var(--v-background-base);
    }
    i {
        font-size: 1em !important;
        color: var(--v-background-base);
    }
    a {
        color: var(--v-background-base);
        text-decoration: underline;
        &:hover {
            color: var(--v-primaryLight-base);
        }
    }
}
</style>
